__webpack_require__.p = "//testbhgst.imgix.net/dist/13788/badshop/client/";